// src/layout/AdminLayout.jsx
import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Avatar,
  Tooltip,
  Paper,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddBoxIcon from "@mui/icons-material/AddBox";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PeopleIcon from "@mui/icons-material/People";

const drawerWidth = 260;

export default function AdminLayout() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const menu = [
    { text: "Artifacts", path: "/admin/artifacts", icon: <DashboardIcon /> },
    {
      text: "Add Artifact",
      path: "/admin/artifacts/add",
      icon: <AddBoxIcon />,
    },
    { text: "QR Codes", path: "/admin/qrcodes", icon: <QrCodeIcon /> },
    { text: "Viewers", path: "/admin/viewers", icon: <PeopleIcon /> },
  ];

  const logout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/");
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: "#0d47a1",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => setOpen((s) => !s)}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            Museum Admin Panel
          </Typography>

          <Tooltip title="Logout">
            <IconButton color="inherit" onClick={logout}>
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="persistent"
        open={open}
        sx={{
          width: open ? drawerWidth : 72,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : 72,
            boxSizing: "border-box",
            background: "#1b2a44",
            color: "#fff",
            transition: "width 200ms",
            overflowX: "hidden",
          },
        }}
      >
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 1, px: 2 }}>
          <Avatar sx={{ bgcolor: "#1565c0" }}>M</Avatar>
          {open && <Typography variant="h6">Museum</Typography>}
        </Toolbar>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.08)" }} />

        <List>
          {menu.map((m) => (
            <ListItemButton
              key={m.path}
              component={NavLink}
              to={m.path}
              sx={{
                color: "inherit",
                px: 3,
                py: 1.2,
                "&.active": {
                  background:
                    "linear-gradient(90deg, rgba(21,101,192,0.16), rgba(21,101,192,0.08))",
                  borderLeft: "4px solid #1565c0",
                },
                "&:hover": {
                  background: "rgba(255,255,255,0.04)",
                },
              }}
            >
              <ListItemIcon sx={{ color: "inherit", minWidth: 36 }}>
                {m.icon}
              </ListItemIcon>
              {open && <ListItemText primary={m.text} />}
            </ListItemButton>
          ))}
        </List>

        <Box sx={{ flex: 1 }} />

        <Paper
          elevation={0}
          sx={{ bgcolor: "transparent", color: "rgba(255,255,255,0.7)", p: 2 }}
        >
          <Typography variant="body2">Server: localhost:5000</Typography>
        </Paper>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
